import { EnvelopeSource } from 'src/app/enum/envelope-source';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { EnvelopeFile } from 'src/app/main-envelope/model/envelope-file.model';
import Segment from 'src/app/modules/settings/model/segment-model';
import { DateTimeInfo } from 'src/app/modules/verification/models/date-time-info';
import { Signature } from './signature';

export class Envelope {
  id: number;
  title: string;
  status: SentEnvelopeStatus;
  expiration: Date;
  fileName: string;
  totalSignatures: number;
  totalRejected: number;
  totalAuthorizers: number;
  totalAuthorizationsCompleted: number;
  totalSignaturesCompleted: number;
  cardOptions?: any;
  checked: boolean;
  creationDate: DateTimeInfo;
  createdByUserId: number;
  suiteUserName: string;
  lastModifiedDate: DateTimeInfo;
  signatories: Array<Signature>;
  authorizers: Array<Signature>;
  responsibles?: Array<Signature>;
  segment: Segment;
  reminderFrequency: number;
  conclutionDate: DateTimeInfo;
  message: string;
  language: number;
  signatoryAccessAuthentication: boolean;
  authorizerAccessAuthentication: boolean;
  responsibleAccessAuthentication: boolean;
  isOrdered: boolean;
  reasonDelete: string;
  userNameDelete: string;
  source: EnvelopeSource;
  includeRubric: boolean;
  isRejectable: boolean;
  rejectedBy: string;
  rejectedDate: DateTimeInfo;
  responsibleName: string;
  totalFiles: number;
  files: Array<EnvelopeFile>;
}
